import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import OptionLayout from './option_layout';

export default function MultiSelectOption({ defaults, option, onRemove, onUpdate }) {
  const childOptionNames = option.options.map(opt => opt.name);
  const currentValues = {};
  const resetValues = {};
  for (const name of childOptionNames) {
    currentValues[name] = !!defaults[name];
    resetValues[name] = false;
  }

  return (
    <OptionLayout
      isOverridden={childOptionNames.some(name => defaults.hasOwnProperty(name))}
      label={option.label}
      onRemove={() => onRemove(childOptionNames)}
      onReset={() => onUpdate(resetValues)}
    >
      <ManagedInput
        options={option.options}
        type="checkboxGroup"
        value={currentValues}
        onValueChange={onUpdate}
      />
    </OptionLayout>
  );
}

MultiSelectOption.propTypes = {
  defaults: PropTypes.object.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
